export enum BluebookEnumTabs {
  All = 'All',
  House = 'House',
  Prospect = 'Prospect',
  Utility = 'Utility',
}
